const typeOrganization = {
  SET_ORGANIZATION_SELECTED: "SET_ORGANIZATION_SELECTED",
  CLEAR_ORGANIZATION: "CLEAR_ORGANIZATION",
};
export default typeOrganization;
